<template>
  <v-dialog max-width="500" v-model="dialog">
    <v-card>
      <div class="py-5 px-4 page-title-block">
        <v-card-title class="pa-0 page-title-block-text">
          {{ $t("movingproducts") }}
        </v-card-title>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider />
      <div class="mt-6 mx-4">
        <div class="inner-container">
          <div class="inner-container-column">
            <span class="name_product_box">
              <span class="name_product">{{ $t("productName") }}:</span>
              <span class="three-dotes">
                {{
                  notification.data
                    ? notification.data[`productName_${$i18n.locale}`]
                    : ""
                }}
              </span>
            </span>
            <div class="timeline">
              <div class="timeline-item">
                <div class="timeline-content">
                  <h4>От куда:</h4>
                  <p>
                    {{ $t("warehouseFieldType.stillage") }}
                    {{
                      notification.data ? notification.data.fromStillage : ""
                    }},
                    {{ $t("warehouseFieldType.carriage") }}
                    {{
                      notification.data ? notification.data.fromCarriage : ""
                    }}
                  </p>
                </div>
              </div>
              <div class="timeline-item">
                <div class="timeline-content">
                  <h4>Куда:</h4>
                  <p>
                    {{ $t("warehouseFieldType.stillage") }}
                    {{ notification.data ? notification.data.toStillage : "" }},
                    {{ $t("warehouseFieldType.carriage") }}
                    {{ notification.data ? notification.data.toCarriage : "" }}
                  </p>
                </div>
              </div>
            </div>
            <span class="responsible_container">
              <span class="responsible_person_label">{{
                $t("designatedPerson")
              }}</span>
              <span class="three-dotes responsible_person_value">
                {{ notification.data ? notification.data.responsible : "" }}
              </span>
            </span>
            <!-- btn by status -->
            <!--CREATED-->
            <v-btn
              @click="startReplace(notification.data.id)"
              v-if="notification?.data?.status === 'CREATED'"
              color="primary"
              :loading="btnLoading"
              class="btn start_btn"
            >
              Начать задачу
            </v-btn>
            <!-- STARTED -->
            <div
              v-if="notification?.data?.status === 'STARTED' && isTaskForMe"
              class="started_container"
            >
              <div class="start_time_container">
                <p>Время начало</p>
                <div class="time-container">
                  <img :src="WatchImage" alt="watch" />
                  <span>{{ dataConverter(notification?.data?.staterAt) }}</span>
                </div>
              </div>
              <v-btn
                @click="endReplace(notification.data.id)"
                color="success"
                :loading="btnLoading"
                class="btn started_btn"
              >
                Завершить
              </v-btn>
            </div>
            <div
              v-if="notification?.data?.status === 'STARTED' && !isTaskForMe"
              class="finished_container"
            >
              <div class="start_time_container">
                <p>{{ $t("status") }}</p>
                <span class="btn btn_process">{{ $t("STARTED") }}</span>
              </div>
              <div class="start_time_container">
                <p>Время начало</p>
                <div class="time-container">
                  <img :src="WatchImage" alt="watch" />
                  <span>{{ dataConverter(notification?.data?.staterAt) }}</span>
                </div>
              </div>
            </div>
            <!-- FINISHED -->
            <div
              v-if="notification?.data?.status === 'FINISHED' && isTaskForMe"
              class="finished_container"
            >
              <div class="start_time_container">
                <p>Время начало</p>
                <div class="time-container">
                  <img :src="WatchImage" alt="watch" />
                  <span>{{ dataConverter(notification?.data?.staterAt) }}</span>
                </div>
              </div>
              <div class="start_time_container">
                <p>Время завершения</p>
                <div class="time-container">
                  <img :src="WatchImage" alt="watch" />
                  <span>{{
                    dataConverter(notification?.data?.finishedAt)
                  }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="notification?.data?.status === 'FINISHED' && !isTaskForMe"
              class="finished_container"
            >
              <div class="start_time_container">
                <p>{{ $t("status") }}</p>
                <span class="btn btn_finished">{{
                  $t("outGoingContractStatus.COMPLETED")
                }}</span>
              </div>
              <div class="start_time_container">
                <p>Время начало</p>
                <div class="time-container">
                  <img :src="WatchImage" alt="watch" />
                  <span>{{ dataConverter(notification?.data?.staterAt) }}</span>
                </div>
              </div>
              <div class="start_time_container">
                <p>Время завершения</p>
                <div class="time-container">
                  <img :src="WatchImage" alt="watch" />
                  <span>{{
                    dataConverter(notification?.data?.finishedAt)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <v-row>-->
        <!--          <v-col cols="12">-->
        <!--            <span style="color: #7a889b; font-weight: 500"-->
        <!--              >{{ $t("productName") }}:-->
        <!--              <span class="three-dotes">-->
        <!--                {{-->
        <!--                  notification.data-->
        <!--                    ? notification.data[`productName_${$i18n.locale}`]-->
        <!--                    : ""-->
        <!--                }}-->
        <!--              </span>-->
        <!--            </span>-->
        <!--          </v-col>-->
        <!--          <v-col cols="12">-->
        <!--            <div>-->
        <!--              <p>-->
        <!--                От куда: {{ $t("warehouseFieldType.stillage") }}-->
        <!--                {{ notification.data ? notification.data.fromCarriage : "" }},-->
        <!--                {{ $t("warehouseFieldType.carriage") }}-->
        <!--                {{ notification.data ? notification.data.toCarriage : "" }}-->
        <!--              </p>-->
        <!--              <p>-->
        <!--                Куда: {{ $t("warehouseFieldType.stillage") }}-->
        <!--                {{ notification.data ? notification.data.fromStillage : "" }},-->
        <!--                {{ $t("warehouseFieldType.carriage") }}-->
        <!--                {{ notification.data ? notification.data.toStillage : "" }}-->
        <!--              </p>-->
        <!--            </div>-->
        <!--          </v-col>-->
        <!--          <v-col cols="12">-->
        <!--            <p-->
        <!--              style="-->
        <!--                color: #7a889b;-->
        <!--                font-weight: 400;-->
        <!--                margin-bottom: 0px !important;-->
        <!--              "-->
        <!--            >-->
        <!--              {{ $t("Назначенное лицо") }}:-->
        <!--            </p>-->
        <!--            <p style="font-weight: 400" class="three-dotes">-->
        <!--              {{ notification.data ? notification.data.responsible : "" }}-->
        <!--            </p>-->
        <!--          </v-col>-->
        <!--          <v-col cols="12">-->
        <!--            <div class="d-flex justify-space-between">-->
        <!--              <div>-->
        <!--                <p-->
        <!--                  style="-->
        <!--                    color: #7a889b;-->
        <!--                    font-weight: 400;-->
        <!--                    margin-bottom: 0px !important;-->
        <!--                  "-->
        <!--                >-->
        <!--                  {{ $t("startDate") }}:-->
        <!--                </p>-->
        <!--                <p style="font-weight: 400" class="time-zone">-->
        <!--                  {{ notification.data ? notification.data.startedAt : "" }}-->
        <!--                </p>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                <p-->
        <!--                  style="-->
        <!--                    color: #7a889b;-->
        <!--                    font-weight: 400;-->
        <!--                    margin-bottom: 0px !important;-->
        <!--                  "-->
        <!--                >-->
        <!--                  {{ $t("endDate") }}:-->
        <!--                </p>-->
        <!--                <p style="font-weight: 400" class="time-zone">-->
        <!--                  {{ notification.data ? notification.data.finishedAt : "" }}-->
        <!--                </p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </v-col>-->
        <!--        </v-row>-->
      </div>
      <v-divider />

      <div
        class="bottom_container d-flex justify-space-between align-center my-4 px-4"
      >
        <div style="gap: 5px" class="bottom_time_container">
          <img :src="WatchImage" alt="watch" />
          <p style="color: #9eabbe; font-size: 12px">
            {{ notification.sentAt }}
          </p>
        </div>
        <div>
          <v-btn
            color="#9EABBE"
            style="color: #ffffff"
            @click="close"
            :loading="loading"
            :disabled="loading"
          >
            {{ $t("close") }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import WatchImage from "../../assets/img/watch_later.png";
export default {
  data() {
    return {
      dialog: false,
      btnLoading: false,
      loading: false,
      notification: {},
      WatchImage,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        return;
      }
    },
  },
  computed: {
    isTaskForMe() {
      return (
        this.notification?.data?.responsibleId ===
        this.$store.state.user.user.id
      );
    },
  },
  methods: {
    async open(id) {
      this.dialog = true;
      this.loading = true;
      try {
        const {
          data: { data },
        } = await this.$http.get(`notification/${id}`);
        this.notification = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    async startReplace(id) {
      this.btnLoading = true;
      try {
        await this.$http.post(`inventarization/replace-start/${id}`);
      } catch (e) {
        console.log(e);
      } finally {
        this.btnLoading = false;
        this.close();
      }
    },
    async endReplace(id) {
      this.btnLoading = true;
      try {
        await this.$http.post(`inventarization/replace-end/${id}`);
      } catch (e) {
        console.log(e);
      } finally {
        this.btnLoading = false;
        this.close();
      }
    },
    dataConverter(timestamp_ms) {
      const date = new Date(timestamp_ms);

      let formatted_date_time =
        date.getDate().toString().padStart(2, "0") +
        "-" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        date.getFullYear() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes().toString().padStart(2, "0");

      return formatted_date_time;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
}

.start_btn {
  color: #fff;
  background: #0096b2;
  text-transform: capitalize;
  margin-left: 32px;
  margin-bottom: 18px;
}

.three-dotes {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 200px;
  vertical-align: middle;
  font-weight: bold;
  color: #48545d;
}
.time-zone {
  background: #f8f9fc;
  border-radius: 6px;
  padding: 13px 12px;
}

.page-title-block {
  display: flex;
  justify-content: space-between;

  &-page-title-block-text {
    font-family: "Rubik", sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 21.33px;
  }
}

.name_product_box {
  display: flex;
  align-items: center;
  gap: 5px;
  .name_product {
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #7a889b;
  }
}

.timeline {
  position: relative;
  padding: 6px 0;
  width: 100%;
}
.timeline:before {
  content: "";
  position: absolute;
  top: 33px; /* Adjusted position to match the dots */
  left: 4px;
  width: 2px;
  height: calc(100% - 90px); /* Adjusted height to match the dots */
  background: #ccc;
}
.timeline-item {
  position: relative;
  margin: 15px 0;
  padding-left: 20px;
}
.timeline-item:before {
  content: "";
  position: absolute;
  top: 2px;
  left: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #ccc;
}
.timeline-content {
  text-align: left;
  padding-left: 14px;
}
.timeline-item h4 {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.59px;
  color: #7a889b;
}
.timeline-item p {
  margin: 5px 0 0;
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.59px;
  color: #48545d;
}

.responsible_container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 34px;
  margin-bottom: 20px;
}

.responsible_person_label {
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.22px;
  color: #7a889b;
}

.responsible_person_value {
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.59px;
  color: #48545d;
}

.time-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 32px;
  background: #f8f9fc;
  padding: 12px;
  border-radius: 6px;
  align-self: start;
  span {
    font-font: "Rubik";
    font-weight: 400;
    font-size: 12px;
    color: #9eabbe;
  }
}

.start_time_container {
  display: flex;
  flex-direction: column;
  gap: 5px;

  p {
    margin-left: 32px;
    margin-bottom: 0;
    font-family: "Rubik", sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: #7a889b;
  }
}

.started_container {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 18px;

  .v-btn.started_btn {
    padding: 20px;
    text-transform: capitalize;
  }
}

.finished_container {
  display: flex;
  margin-bottom: 18px;
  margin-left: 32px;
  gap: 12px;

  .start_time_container {
    p {
      margin-left: 0px;
    }

    .time-container {
      margin-left: 0px;
    }
  }
}

.btn_finished {
  background: #1780151f;
  color: #178015;
  font-weight: 400;
  padding: 10px 12px;
}

.btn_process {
  background: #fdf3e5;
  color: #f0a126;
  font-weight: 400;
  padding: 10px 12px;
}

.bottom_time_container {
  display: flex;
  align-items: center;
  gap: 10px;

  p {
    margin-bottom: 0;
  }
}

.bottom_container {
  align-items: center;
}
</style>
